Bingo.DynamicCustomersMultiselects = {};

Bingo.DynamicCustomersMultiselects.init = () => {
    const propertySellersInput = $('.js-signSaModal__propertySellersSelectize');
    const propertyBuyersInput = $('.js-signSaModal__propertyBuyersSelectize');
    const sellersSelectize = propertySellersInput[0].selectize;
    const buyersSelectize = propertyBuyersInput[0].selectize;

    sellersSelectize.on('item_add', (optionId) => {
        buyersSelectize.removeOption(optionId, true);
    });

    sellersSelectize.on('item_remove', (optionId, option) => {
        const optionText = option.context.firstChild.innerText;
        buyersSelectize.addOption({
            value: optionId,
            text: optionText,
        });
    });

    buyersSelectize.on('item_add', (optionId) => {
        sellersSelectize.removeOption(optionId, true);
    });

    buyersSelectize.on('item_remove', (optionId, option) => {
        const optionText = option.context.firstChild.innerText;
        sellersSelectize.addOption({
            value: optionId,
            text: optionText,
        });
    });
};
